module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Pages</span></div>\r\n<div class=\"row prop-detail\">\r\n    <div class=\"col-md-12 form-group-flex\">\r\n        <input type=\"radio\" name=\"pageType\" checked=\"checked\" value=\"all\" class=\"form-radio-group\"/>\r\n        <label class=\"form-group-label\">All</label>\r\n    </div>\r\n    <div class=\"col-md-12 form-group-flex\">\r\n        <input type=\"radio\" name=\"pageType\" value=\"current\" class=\"form-radio-group\"/>\r\n        <label class=\"form-group-label\">Current</label>\r\n    </div>\r\n    <div class=\"col-md-12 form-group-flex\">\r\n        <input type=\"radio\" name=\"pageType\" value=\"specific\" class=\"form-radio-group\"/>\r\n        <label class=\"form-group-label\">Specific</label>\r\n    </div>\r\n    <div class=\"col-md-12\" style=\"padding-right: 0px;\">\r\n        <select id=\"selectedPageSpecific\" name=\"selectedPageSpecific\" size=\"3\" multiple style=\"width: 100%; height: 100px;\" disabled >\r\n\r\n        </select>\r\n    </div>\r\n</div>")
  }
  return __output;

}